import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLabel24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLabel24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.5 10.79V4.5h6.29a1.5 1.5 0 0 1 1.06.44l8.29 8.29a1.5 1.5 0 0 1 0 2.121l-4.789 4.79a1.5 1.5 0 0 1-2.121 0l-8.29-8.29a1.5 1.5 0 0 1-.44-1.061m-.621 2.121A3 3 0 0 1 3 10.79V4.5A1.5 1.5 0 0 1 4.5 3h6.29a3 3 0 0 1 2.121.879l8.29 8.29a3 3 0 0 1 0 4.243l-4.79 4.79a3 3 0 0 1-4.242 0zm5.524-4.403a.895.895 0 1 1-1.79 0 .895.895 0 0 1 1.79 0m1.5 0a2.395 2.395 0 1 1-4.79 0 2.395 2.395 0 0 1 4.79 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLabel24);
